import { Link } from "react-router-dom";

interface FeaturedArticle {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: string;
  imageUrl: string;
}

const featuredArticles: FeaturedArticle[] = [
  {
    id: 1,
    title: "17c每日大赛新手入门指南：从零开始的参赛攻略",
    excerpt: "刚接触17c每日大赛？别担心！本指南将带你从注册到参赛，一步步掌握每日赛事的全部流程和技巧。",
    category: "新人专属",
    date: "2026-08-01",
    readTime: "8分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Energetic%20modern%20competitive%20gaming%20atmosphere%20warm%20orange%20and%20amber%20tones%20abstract%20geometric%20shapes%20digital%20arena%20glowing%20accents%20editorial%20style&width=800&height=480&seq=home-article-01&orientation=landscape",
  },
  {
    id: 2,
    title: "2026年8月竞技赛事日历：本月必参加的5场大赛",
    excerpt: "8月赛事精彩纷呈，我们为你精选了5场不可错过的重磅赛事，提前了解、做好准备，赢在起跑线上。",
    category: "竞技赛事",
    date: "2026-08-03",
    readTime: "10分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Dynamic%20calender%20style%20composition%20with%20golden%20trophy%20silhouettes%20warm%20amber%20gradient%20background%20competitive%20gaming%20theme%20soft%20particles%20floating%20professional%20editorial&width=800&height=480&seq=home-article-02&orientation=landscape",
  },
  {
    id: 3,
    title: "深度解析：17c每日大赛的积分系统与排名机制",
    excerpt: "了解积分计算方式，掌握排名提升技巧，让你在每日大赛中更有策略地参赛。",
    category: "竞技赛事",
    date: "2026-07-28",
    readTime: "6分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20data%20analytics%20dashboard%20concept%20with%20warm%20orange%20accent%20colors%20abstract%20ranking%20charts%20glowing%20lines%20professional%20editorial%20style%20minimalist&width=800&height=480&seq=home-article-03&orientation=landscape",
  },
];

export default function FeaturedArticles() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-12">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
              热门攻略
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新赛事攻略
            </h2>
          </div>
          <Link
            to="/article/1"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-200/70 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-semibold">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 mb-4 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span><i className="ri-time-line mr-1"></i>{article.readTime}</span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/article/1"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium"
          >
            查看全部攻略 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}